function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.01 9.25l-7.51-1 .01-2.22 7.5 3.22zm0 5.5l-7.5 3.22-.01-2.22 7.51-1z",
  opacity: ".3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fillOpacity: ".87"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.51 3l-.01 7 10 2-10 2 .01 7 20.99-9L1.51 3zM3.5 8.25V6.03l7.51 3.22-7.51-1zm.01 7.5v2.22l7.51-3.22-7.51 1z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fillOpacity: ".87"
}));